module.exports = __webpack_public_path__ + "static/other-4b16931f9a5bd20e8b7d479d66f759af.svg";